import { render, staticRenderFns } from "./ActionGroupSeparator.vue?vue&type=template&id=2a8c5fc4&"
import script from "./ActionGroupSeparator.vue?vue&type=script&lang=js&"
export * from "./ActionGroupSeparator.vue?vue&type=script&lang=js&"
import style0 from "./ActionGroupSeparator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports